"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("../../../const");

var _useStyles = require("../../../hooks/useStyles");

var _heroSlide = require("../hero-slide.styled");

var _heroSlideContent = require("./hero-slide-content");

var _heroSlideUi = require("./hero-slide-ui.styled");

var _style = _interopRequireDefault(require("./style"));

var _responsiveImage = _interopRequireDefault(require("../../image/responsive-image"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var HeroSlideUi = function HeroSlideUi(props) {
  var incomingType = props.type,
      bgImages = props.bgImages,
      layoutType50 = props.layoutType50,
      layoutTypeBlock = props.layoutTypeBlock,
      textBackgroundColor = props.textBackgroundColor,
      contentProps = _objectWithoutProperties(props, ["type", "bgImages", "layoutType50", "layoutTypeBlock", "textBackgroundColor"]);

  var type = function (incomingType) {
    switch (incomingType) {
      case 'type_50':
        return 'b';

      default:
        return 'a';
    }
  }(incomingType);

  var styles = (0, _useStyles.useStyles)(type, _style.default);
  var isColorBlock = incomingType === 'type_block';
  var layout = isColorBlock ? layoutTypeBlock : layoutType50;
  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: {
      styles: styles
    }
  }, /*#__PURE__*/_react.default.createElement(_heroSlide.CarouselWrapper, {
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_HERO_SLIDE_B,
    is50Block: !isColorBlock
  }, /*#__PURE__*/_react.default.createElement(_heroSlideUi.HeroSlideStyled, {
    layout: layout,
    textBackgroundColor: textBackgroundColor
  }, /*#__PURE__*/_react.default.createElement(_heroSlideContent.HeroSlideContent, _extends({
    type: incomingType,
    textBackgroundColor: textBackgroundColor
  }, contentProps)), /*#__PURE__*/_react.default.createElement(_heroSlideUi.HeroImageBlock, {
    isCovered: isColorBlock
  }, /*#__PURE__*/_react.default.createElement(_responsiveImage.default, {
    bgImages: bgImages,
    fit: "cover"
  })))));
};

var _default = HeroSlideUi;
exports.default = _default;